import React from "react";
import { connect } from "react-redux";
import {
  StyledForm,
  FormGroup,
  UpgradeText,
  ChannelFormSection,
  FieldHead,
  UpgradeButtonLink,
  UpgradeButtonLinkContainer,
} from "./styledComponents";
import Button from "components/Button";
import { ChannelInputField } from "./components";
import Divider from "components/Divider";
import { colors } from "globalStyles";
import { Controller } from "react-hook-form";
import { t } from "copy/t";
import UpgradeCta from "containers/UpgradeCta";

export const TermsForm = ({
  edit,
  submitting,
  onSubmit,
  termsText,
  permissionRole,
  form
}) => {
  const { control, handleSubmit } = form;

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <FormGroup>
        <ChannelFormSection>
          <FieldHead className="brand">
            <strong>Custom Guest Terms</strong>
            <h3 className="customize-the-message">
              Add custom guest policies to Movebooth's standard{" "}
              <a
                href="https://movebooth.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: colors.MAIN_COLOR,
                  textDecoration: "underline",
                }}
              >
                terms of service & privacy policy.
              </a>
            </h3>
          </FieldHead>
          <div className="field-text">
            {["super_admin", "enterprise_admin", "plus", "pro"].includes(
              permissionRole
            ) ? (
              <Controller
                control={control}
                name="terms_text"
                render={({ field: { ref, ...fieldRest } }) => (
                  <ChannelInputField
                    name="terms_text"
                    label="custom terms"
                    placeholder={t("placeholders.standardGuestTerms")}
                    type="text"
                    multiline={5}
                    field={fieldRest}
                    {...fieldRest}
                    value={termsText}
                  />
                )}
              />
            ) : (
              <div style={{ marginTop: "20px" }}>
                <UpgradeButtonLinkContainer>
                  <UpgradeCta as={UpgradeButtonLink}>
                    Upgrade to add custom guest terms
                  </UpgradeCta>
                </UpgradeButtonLinkContainer>
              </div>
            )}
          </div>
        </ChannelFormSection>
      </FormGroup>
      <Divider marginBottom={48}></Divider>
      <UpgradeText className="left-pos pdd-20">
        Looking for more? Send us a suggestion.
      </UpgradeText>
      <div className="channel-forms__group">
        <Button type="submit" disabled={submitting}>
          {edit ? "Save" : "Save & Finish"}
        </Button>
      </div>
    </StyledForm>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(TermsForm);
